import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, FeatureCard, SectionHead } from "../components/site/Common";
import BookingWidget from "../components/site/BookingWidget";
import { SERVICE_PAGES } from "../mock";
import { RelatedLinks } from "../components/site/RelatedLinks";
import { SeoExtras } from "../components/site/SeoExtras";
import { useReveal } from "../lib/lang";

const ServicePage = ({ kindOverride }) => {
  const { kind } = useParams();
  const k = kindOverride || kind;
  const s = SERVICE_PAGES[k] || SERVICE_PAGES.airport;
  useReveal();
  const preset = s.hourly ? { type: "hourly" } : s.preset ? { pickup: s.preset } : {};
  return (
    <div data-testid={`service-page-${k}`}>
      <PageHero image={s.image} eyebrow={s.eyebrow} title={s.title} sub={s.sub}>
        <a href="#book" className="mt-5 sm:mt-8 inline-flex items-center gap-2 rounded-full bg-[#E3CBA5] text-[#183C35] font-semibold px-5 sm:px-6 py-2.5 sm:py-3 text-[14.5px] sm:text-[16px] hover:bg-[#EBD8B8] transition-colors duration-200" data-testid="service-hero-cta">
          {s.cta} <ArrowRight className="w-4 h-4" />
        </a>
      </PageHero>
      <section className="py-12 sm:py-24">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHead eyebrow="What's included" title={s.title2} />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5 mt-6 sm:mt-12">
            {s.items.map(([i, t, d]) => <FeatureCard key={t} icon={i} title={t} text={d} />)}
          </div>
        </div>
      </section>
      <section id="book" className="pb-12 sm:pb-24 scroll-mt-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="reveal rounded-[22px] sm:rounded-[28px] bg-[#1A3C37] p-4 sm:p-10 grid lg:grid-cols-[1fr_572px] gap-5 sm:gap-10 items-center">
            <div>
              <h3 className="font-serif-d text-[24px] sm:text-[32px] font-semibold text-[#F7F3EA]">Ready when you land?</h3>
              <p className="mt-3 text-[17px] text-[#F7F3EA]/80">{s.readyText}</p>
              <Link to="/contact" className="mt-6 inline-flex items-center gap-2 text-[#E3CBA5] hover:text-[#F7F3EA] transition-colors">Need a custom quote? Contact us <ArrowRight className="w-4 h-4" /></Link>
            </div>
            <BookingWidget key={k} preset={preset} />
          </div>
        </div>
      </section>
      <SeoExtras path={k === "airport" ? "/airport-transfers" : k === "chauffeur" ? "/chauffeur" : `/transfers/${k}`} page={k} />
      <RelatedLinks current={k === "airport" ? "/airport-transfers" : k === "chauffeur" ? "/chauffeur" : `/transfers/${k}`} />
    </div>
  );
};

export default ServicePage;
